import React from 'react';
import {
    faBan,
    faBug,
    faBuilding,
    faCheck,
    faCheckCircle,
    faClock,
    faCloud,
    faCoins,
    faCopy,
    faCreditCard,
    faExternalLink,
    faFileContract,
    faFileSignature,
    faFire,
    faHouseReturn,
    faInfinity,
    faMoneyCheckAlt,
    faRadar,
    faRocket,
    faSackDollar,
    faSearch,
    faShield,
    faShieldCheck,
    faShippingFast,
    faShoppingCart,
    faSignature,
    faTimes,
    faSign,
    faUserEdit,
    faUsers,
    faUserTie,
    faStar,
    faWrench,
    faPresentation,
    faGift,
} from '@fortawesome/pro-light-svg-icons';
import { faShieldAlt } from '@fortawesome/pro-regular-svg-icons';
import { SanityIcon } from '../../../lib/landingPage';
import { Wrapper } from '../Wrapper';
import { FontAwesomeIcon } from '../../../components/FontAwesomeIcon';
import {
    faFacebookF,
    faInstagram,
    faLinkedin,
    faYoutube,
} from '@fortawesome/free-brands-svg-icons';

const iconMap = [
    faBan,
    faBuilding,
    faCheck,
    faCheckCircle,
    faClock,
    faCloud,
    faSign,
    faCoins,
    faCopy,
    faCreditCard,
    faExternalLink,
    faFacebookF,
    faFileContract,
    faFileSignature,
    faFire,
    faGift,
    faHouseReturn,
    faInfinity,
    faInstagram,
    faLinkedin,
    faMoneyCheckAlt,
    faPresentation,
    faRadar,
    faRocket,
    faSackDollar,
    faSearch,
    faShield,
    faShieldAlt,
    faShieldCheck,
    faShippingFast,
    faShoppingCart,
    faSignature,
    faStar,
    faTimes,
    faUserEdit,
    faUsers,
    faUserTie,
    faYoutube,
    faWrench,
].reduce(
    (obj, icon) => ({
        ...obj,
        [icon.iconName]: icon,
    }),
    {}
);

export type IconProps = SanityIcon;

export const Icon = Wrapper(({ slug }: IconProps): JSX.Element => {
    return (
        // eslint-disable-next-line
        // @ts-ignore
        <FontAwesomeIcon icon={iconMap[slug] ?? faBug} />
    );
}, 'icon');
